<template>
  <transition name="fade">
    <div
      v-if="showBanner"
      :class="[
        'fixed top-0 left-0 w-full z-50 text-white text-center py-2 shadow-md',
        bannerType === 'offline' ? 'bg-red-600' : 'bg-green-600'
      ]"
      style="z-index: 9999; font-size: 16px; font-weight: bold;"
    >
      {{
        bannerType === 'offline' ? '🔌 You’re offline — changes may not be saved.' : '✅ Back online — changes are syncing.'
      }}
    </div>
  </transition>
</template>

<script lang="ts" setup>
import {ref, watch} from 'vue';
import {useNetworkStatus} from '@/composables/useNetworkStatus';

const {online} = useNetworkStatus();
const showBanner = ref(!online.value);
const bannerType = ref<'offline' | 'online'>('offline');

watch(online, (isOnline) => {
  if (!isOnline) {
    bannerType.value = 'offline';
    showBanner.value = true;
  } else {
    bannerType.value = 'online';
    showBanner.value = true;

    // Auto-hide after 2 seconds
    setTimeout(() => {
      showBanner.value = false;
    }, 2000);
  }
});
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
